import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Widget, addResponseMessage, deleteMessages, toggleWidget } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import { Toast } from 'primereact/toast';
import { ModalInstall } from './ModalInstall';
        
const Main = () => {
  const location = useLocation();
  const [messageCount, setMessageCount] = useState(location.state?.messageCount || 0);
  const [chatHistory, setChatHistory] = useState([]);
  const toast = useRef(null);

  const checkConnection = async () => {
    try {
      await fetch('https://www.google.com?no-sw=true', { mode: 'no-cors' });
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tienes conexión a Internet', life: 3000 });
    }
  };

  // Llama a checkConnection al inicio del componente
  useEffect(() => {
    checkConnection();
  }, []);

  // Abre el widget automáticamente al montar el componente
  useEffect(() => {
    toggleWidget();
  }, []);

  const openUrlAutomatically = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    const match = urlPattern.exec(text);
    if (match) {
      window.open(match[0], '_blank');
    }
  }

  useEffect(() => {
    if(messageCount === 0){
      addResponseMessage('¡Bienvenido al chat de CarbonSeq!');
      setMessageCount(1);
    }
  }, []);

  const handleNewUserMessage = async (question) => {
    try {
      // Cerrar el teclado
      const inputElement = document.querySelector('.rcw-send');
      if (inputElement) {
        inputElement.focus();
        inputElement.blur();
      }

      const url_server = "";
      const response = await fetch(url_server + '/api_carbonseq/ask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ question: question, history: chatHistory }),
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Error en la respuesta de la API');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let botResponse = '';
      let completeResponse = '';
      let scrollCount = 0;
      
      // Añadir un mensaje inicial vacío
      addResponseMessage('');

      // Esperar un breve momento para asegurarse de que el mensaje se ha añadido
      setTimeout(() => {
        // Obtener el último mensaje añadido después de añadir el mensaje vacío
        const messages = document.querySelectorAll('.rcw-message-text');
        const lastMessageElement = messages[messages.length - 1];

        // Leer el stream de datos
        (async () => {
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, { stream: true });
            completeResponse += chunk;

            // Buscar el marcador de inicio del historial
            const historyMarkerIndex = completeResponse.indexOf("\nhistorial: ");
            if (historyMarkerIndex !== -1) {
              // Separar la respuesta del historial
              botResponse = completeResponse.substring(0, historyMarkerIndex).trim();
              const historyJson = completeResponse.substring(historyMarkerIndex + 12).trim();
              // Actualizar el historial
              setChatHistory(JSON.parse(historyJson));
              // Salir del bucle ya que hemos procesado todo
              break;
            }

            // Transformar texto en negrita y encabezados de nivel 3
            const formattedResponse = completeResponse
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/### (.*?)\n/g, '<h3>$1</h3>\n');

            // Actualizar el contenido del último mensaje
            if (lastMessageElement) {
              lastMessageElement.innerHTML = formattedResponse;
              
              // Desplazar hacia abajo cada vez que se actualiza el mensaje, hasta un máximo de 100 veces
              if (scrollCount < 100) {
                const messagesContainer = document.querySelector('.rcw-messages-container');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    scrollCount++; // Incrementar el contador
                }
              }
            }
          }
        })();
      }, 100); // Ajusta el tiempo de espera según sea necesario

      openUrlAutomatically(botResponse);
    } catch (error) {
      console.error('Error al obtener respuesta de ChatGPT:', error);
    }
  };

  return (
      <><ModalInstall /><div className="body-div flex flex-column align-items-center">
      <Toast ref={toast} />
      <Widget
        handleNewUserMessage={handleNewUserMessage}
        subtitle={null}
        emojis={true}
        title={"CarbonSeq Chat"}
        showTimeStamp={false}
        showCloseButton={false}
        senderPlaceHolder={"Escribe tu mensaje..."}
        style={{ maxWidth: '100%', margin: '0 auto' }} />
    </div></>
  );
};

export default Main;
